import React, { createContext, useContext } from 'react';

interface AuthContextType {
  origin: string | null;
  expirationTime: number;
  token: string | null;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

interface AuthProviderProps {
  children: React.ReactNode;
  origin: string | null;
  expirationTime: number;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({
  children,
  origin,
  expirationTime,
}) => {
  const contextValue = React.useMemo(
    () => ({
      origin,
      expirationTime,
      token: sessionStorage.getItem('token')
    }),
    [origin, expirationTime]
  );

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
